import React from 'react';
import { Box } from '@mui/material';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

/**
 * Reusable Pie Chart component for sales performance
 * Aggregates sales by order type (Dine In vs Pick Up)
 * @param {Array} data - Chart data with timeSlot, dineIn, pickUp properties
 * @param {Object} customStyles - Optional custom styling for the container
 */
const SalesPieChart = ({ data, customStyles = {} }) => {
  // Aggregate data for pie chart
  const aggregatedData = React.useMemo(() => {
    const totalDineIn = data.reduce((sum, item) => sum + item.dineIn, 0);
    const totalPickUp = data.reduce((sum, item) => sum + item.pickUp, 0);
    const totalDelivery = data.reduce((sum, item) => sum + (item.delivery || 0), 0);

    return [
      { name: 'Dine In', value: totalDineIn, fill: '#1976d2' },
      { name: 'Pick Up', value: totalPickUp, fill: '#00897b' },
      { name: 'Delivery', value: totalDelivery, fill: '#6a1b9a' },
    ];
  }, [data]);

  const renderCustomLabel = ({ name, value, percent }) => {
    return `${name}: ₹${value.toLocaleString()} (${(percent * 100).toFixed(1)}%)`;
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto", ...customStyles }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <ResponsiveContainer width="100%" height={400}>
          <PieChart>
            <Pie
              data={aggregatedData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomLabel}
              outerRadius={120}
              fill="#8884d8"
              dataKey="value"
              animationDuration={1500}
            >
              {aggregatedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [`₹${value.toLocaleString()}`, '']}
              contentStyle={{
                backgroundColor: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                fontSize: "14px",
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default SalesPieChart;
